<template>
  <div class="pre-complete-modal text-center">
    <span class="warning-icon">
      <img src="/img/warning.png" alt="warning">
    </span>

    <template>
      <h2>Please notice</h2>
      <p>
        Are you sure you want to complete this styling even though the customer asked to receive another Sneak Peek.
      </p>
      <div class="buttons flex justify-content-around margin-top">
        <button class="bg-dark-blue flex margin-auto" @click="$emit('close')">
          <SvgFile name="back" color="#fff" size="12" />
          <span class="small-margin-left">Go Back</span>
        </button>
        <button class="bg-sunset-orange" @click="$emit('finalizeOrder')">Complete</button>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import Product from './Product.vue'

let loader

export default {
  name: 'ConfirmCompleteModal',
  data () {
    return {
      preCompleteModalShow: 1,
      reason: ''
    }
  }
}
</script>

<style lang="less" scoped>
.pre-complete-modal {
  &.second {
    margin-right: -20px;
    margin-left: -20px;
  }

  .warning-icon {
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 50%;
    background: #F2F2F2;
    line-height: 60px;
    border: 2px solid #FFF;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .buttons {
    button {
      border-radius: 6px;
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,.2);
    }
  }
}
</style>
